import api from 'ApiConfig';

const departmentService = {
  // ➕ Create Department
  createDepartment: async (departmentData) => {
    return api.post('/superadmin/create-department', departmentData);
  },

  // 📥 Get All Departments
  getAllDepartments: async () => {
    return api.get('/superadmin/get-all-departments');
  },

  // 📄 Get Single Department by ID
  getDepartmentById: async (departmentId) => {
    return api.get(`/superadmin/get-department/${departmentId}`);
  },

  // ✏️ Update Department
  updateDepartment: async (departmentId, payload) => {
    return api.post(`/superadmin/update-department/${departmentId}`, payload);
  },

  // ❌ Delete Department
  deleteDepartment: async (departmentId) => {
    return api.post(`/superadmin/delete-department/${departmentId}`);
  },
};

export default departmentService;
